import { render, staticRenderFns } from "./IssueEditor.vue?vue&type=template&id=c486006e&scoped=true&"
import script from "./IssueEditor.vue?vue&type=script&lang=ts&"
export * from "./IssueEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c486006e",
  null
  
)

export default component.exports